import { components, services } from '@/utils'

import selectorOwner from '@/components/selector/owner'
import nameField from '@/components/services/otp-settings/commons/form/name'

const serviceNameViaPoint = services['otp-settings/widgets'].split('/').join('.')
const serviceNameKebab = services['otp-settings/widgets'].split('/').join('-')

function renderNameField(h) {
  return h(
    nameField,
    {
      props: {
        value: this.proxy.name,
        isNew: this.isNew,
        disabled: this.disabled,
        service: serviceNameViaPoint
      },
      on: {
        input: event => {
          this.proxy.name = event
        }
      }
    }
  )
}

function renderOwnerField(h) {
  return h(
    selectorOwner,
    {
      props: {
        value: this.proxy.ownerId,
        disabled: this.disabled || !this.isNew,
        dense: true,
        combobox: true,
        required: true
      },
      on: {
        input: event => {
          this.proxy.ownerId = event
        }
      }
    }
  )
}

function renderIsActiveField(h) {
  return h(
    components.switch,
    {
      props: {
        value: this.proxy.isActive,
        label: this.getTranslate(`${serviceNameViaPoint}.labels.isActive`),
        disabled: this.disabled
      },
      on: {
        input: event => {
          this.proxy.isActive = event
        }
      }
    }
  )
}
function renderIsBlockedField(h) {
  if (this.checkPermissions(`advanced.${serviceNameViaPoint}.update`)) {
    return h(
      components.switch,
      {
        props: {
          value: this.proxy.isBlocked,
          label: this.getTranslate(`${serviceNameViaPoint}.labels.isBlocked`),
          disabled: this.disabled
        },
        on: {
          input: event => {
            this.proxy.isBlocked = event
          }
        }
      }
    )
  }
}
function renderCaptchaField(h) {
  return h(
    components.switch,
    {
      props: {
        value: this.proxy.captchaIsRequired,
        label: this.getTranslate(`${serviceNameViaPoint}.labels.captchaIsRequired`),
        disabled: this.disabled
      },
      on: {
        input: event => {
          this.proxy.captchaIsRequired = event
        }
      }
    }
  )
}
function renderFlags(h) {
  return h(
    components.card,
    {
      class: `${serviceNameKebab}-form__flags`,
      props: {
        title: this.getTranslate(`${serviceNameViaPoint}.titles.settings`),
        rounded: true,
        outline: true,
        dashed: true
      }
    },
    [
      renderIsActiveField.call(this, h),
      renderIsBlockedField.call(this, h),
      renderCaptchaField.call(this, h)
    ]
  )
}

export default function(h) {
  return h(
    components.form,
    {
      class: {
        [`${serviceNameKebab}-form`]: true,
        [`${serviceNameKebab}-form--new`]: this.isNew
      }
    },
    [
      renderNameField.call(this, h),
      renderOwnerField.call(this, h),
      renderFlags.call(this, h)
    ]
  )
}
